import React, { useState, useEffect, useCallback } from "react";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Skeleton from "react-loading-skeleton";
import axios from "axios";

const PublicationCard = ({ value }) => {
  // const {
  //   name,
  //   description,
  //   svn_url,
  //   stargazers_count,
  //   languages_url,
  //   language,
  //   pushed_at,
  // } = value;

  {console.log(value)}
  return (
    <Col md={10} className="mx-auto ">
        <div class="card text-center" style={{width: "100%"}} >
        <div class="card-body">
            <h5 class="card-title">{value.title}</h5>
            <a href={value.url} class="btn btn-primary" target="_blank">Link to paper</a>
        </div>
        </div>
    </Col>
  );
};

export default PublicationCard;